"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var validateMobile = function validateMobile(email) {
    var re = /^[+](393|(?!00)(?!39)\d{3})\d{2,10}$/;
    return re.test(email);
  };
  return function (input) {
    return validateMobile(input);
  };
};

;


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/mobile.filter.js
// module id = 148
// module chunks = 2